import PaymentsRepository from '../../domain/repositories/PaymentsRepository';
import PaymentsDataStoreFactory from '../factories/PaymentsDataStoreFactory';
import PaymentsDataStore from '../datastores/PaymentsDataStore';

export default class PaymentsDataRepository implements PaymentsRepository {
  getPaymentBanks() {
    const paymentBanksDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentBanksDataStore.getPaymentBanks();
  }

  getPendingPayments() {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getPendingPayments();
  }

  getPaidPayments(period: string) {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getPaidPayments(period);
  }

  getBenefitInstallments() {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getBenefitInstallments();
  }

  getPaymentVouchers(itemNumber: any) {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getPaymentVouchers(itemNumber);
  }

  generatePaymentVoucher(
    companyID: string,
    documentNumber: string,
    documentType: string,
    internalSeries: string,
    documentDate: string,
    totalAmount: number
  ) {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.generatePaymentVoucher(
      companyID,
      documentNumber,
      documentType,
      internalSeries,
      documentDate,
      totalAmount
    );
  }

  getPaymentPeriods() {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getPaymentPeriods();
  }

  getPaymentsByPeriod(period: string) {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getPaymentsByPeriod(period);
  }

  getBenefitInstallmentsInfo() {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.getBenefitInstallmentsInfo();
  }

  activateBenefitInstallments(isActivate: boolean) {
    const paymentsDataStore: PaymentsDataStore =
      PaymentsDataStoreFactory.create();
    return paymentsDataStore.activateBenefitInstallments(isActivate);
  }
}
